import {
  FormControl,
  FormLabel,
  TextField,
  Box,
  Button,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Backdrop
} from "@mui/material";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ErrorMessage } from "formik";
import SendIcon from "@mui/icons-material/Send";
import { Col, Row } from "react-bootstrap";
import * as React from "react";

import { Fragment, useCallback, useEffect, useState } from "react";
import RequiredAsterisk from "../components/RequiredAsterisk";
import DeliveryAddress from "./components/DeliveryAddress";
import { DeliveryAlert } from "./components/DeliveryAlert";
import { axiosPrivate } from "../api/axios";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { Link, useNavigate } from "react-router-dom";
import { useSTCProcessing } from "../hooks/useStcProcessing";
import useAuth from "../hooks/useAuth";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

const CheckOutForm1 = ({ data, setData, next }) => {
  const [loadingDeliveryAddresses, setLoadingDeliveryAddresses] = useState(false);
  const [loadingPickupAddresses, setLoadingPickupAddresses] = useState(false);
  const [showFreightModal, setShowFreightModal] = useState(false);
  const [showSTCModal, setShowSTCModal] = React.useState(false);

  const [pickupAddresses, setPickupAddresses] = useState({});
  const [deliveryAddresses, setDeliveryAddresses] = useState({});
  const { setCartItems, removeFromCart, cartItems } = useShoppingCart();
  const navigate = useNavigate();
  const { processSTCForPostcode } = useSTCProcessing();
  const { auth } = useAuth();

  const handleSTCChange = (e, handleChange) => {
    if (e.target.value === '1') {
      setShowSTCModal(true);
    } else {
      setData(prev => ({ ...prev, trading_stc: e.target.value }));
      handleChange(e);
    }
  };

  const handleSTCConfirm = (handleChange) => {
    setData(prev => ({ ...prev, trading_stc: '1' }));
    handleChange({
      target: {
        value: '1',
        name: 'trading_stc'
      }
    });
    setShowSTCModal(false);
  };

  let mySchema = (data) => {


    let baseSchema2, baseSchema3, baseSchema4 = {}

    let baseSchema1 = {
      delivery_method: Yup.string().required('The delivery method is required.'),
      shipping: Yup.string().required('The pickup or delivery details are required. You can choose between pickup or delivery. Delivery services are also available.'),
      install_date: Yup.string().required('Install date is required.'),
    };

    if (data.delivery_method === '1') {
      baseSchema2 = {
        pickup_by: Yup.string().required('Pickup by is required.')
      }

      /* Transport agency selection requires transport agency name. */
      if (data.pickup_by === '1') {
        baseSchema2 = {
          pickup_by: Yup.string().required('Pick-up by is required.'),
          pickup_by_agency: Yup.string().required('Transport agency company name is required.'),
        }

      }

    }



    if (data.delivery_method === '3') {
      baseSchema3 = {
        delivery_firstname: Yup.string().required('Firstname is required.'),
        delivery_lastname: Yup.string().required('Lastname is required.'),
        delivery_number_street: Yup.string().required('Street & Number Name is required.'),
        delivery_suburb: Yup.string().required('Street & Number Name is required.'),
        delivery_state: Yup.string().oneOf(["", "ACT", "QLD", "SA", "NT", "QLD", "VIC", "WA", "NSW", "TAS"]).required('You must select an Oz state!!'),
        delivery_postcode: Yup.number().min(799, 'Postcode is out of range').max(9999, 'Postcode out of range.').required('Postcode is required.'),
      };
    }

    if (data.delivery_method === '2' || data.delivery_method === '3') {

      baseSchema4 = {
        delivery_service: Yup.string().required().label('Delivery service')
      }

    }

    let baseSchema5 = {
      install_date: Yup.string().required('Install date is required.'),
      trading_stc: Yup.string().required('Are you trading is required.'),
      customer_order_no: Yup.string().required('Purchase Order/Customer Reference is required.'),
    };


    let Schema = {
      ...baseSchema1,
      ...baseSchema2,
      ...baseSchema3,
      ...baseSchema4,
      ...baseSchema5,

    }

    return Yup.object().shape(Schema);
  }

  const addDeliveryService = (service_id) => {

    removeFromCart(0);
    let product = {};

    /** TODO: Pull accessories info from database endpoint */

    if (service_id === '1') {

      product = { ID: 0, STOCKCODE: 'H-DWAY-DROP&GO', DESCRIPTION: 'Driveway Drop & Go', SELLPRICE: '110' }

    } else if (service_id === '2') {

      product = { ID: 0, STOCKCODE: 'H-FULL-DROP&GO', DESCRIPTION: 'Full Drop and Go', SELLPRICE: '150' }

    } else if (service_id === '3') {
      product = { ID: 0, STOCKCODE: 'H-FREIGHT', DESCRIPTION: 'Freight Transport', SELLPRICE: '0' } // Adjust price as needed
    }

    setCartItems(currItems => {

      return [...currItems, {
        id: product.ID,
        quantity: 1,
        description: product.DESCRIPTION,
        stockcode: product.STOCKCODE,
        price: product.SELLPRICE
      }]

    })

  }

  const handleFreightConfirm = () => {
    setShowFreightModal(false);
  };

  const handleSubmit = (values) => {
    next(values, false);
  }

  const getDeliveryAddresses = useCallback(async () => {

    setLoadingDeliveryAddresses(true);
    await axiosPrivate.get('/api/address/deliver/list', {
      withCredentials: true
    }).then((response) => {
      //setPickup(response.data.pickup);
      setDeliveryAddresses(response.data);
    }).catch((error) => {

      console.log(error.message)

      if (error.response.status === 401) {
        console.log('Redirected to login. (401)');
        navigate('/login');
      }

    }).finally(() => {
      setLoadingDeliveryAddresses(false);
    });

  }, [navigate]);

  const getPickupAddresses = useCallback(async () => {
    setLoadingPickupAddresses(true);

    await axiosPrivate.get('/api/address/pickup/list').then((response) => {
      setPickupAddresses(response.data);
    }).catch((error) => {

      if (error?.response?.status === 401) {
        console.log('Redirected to login. (401)');
        navigate('/login');
      }
      console.log(error)

    }).finally(() => {
      setLoadingPickupAddresses(false);
    });

  }, [navigate]);

  useEffect(() => {

    getPickupAddresses().then();

    getDeliveryAddresses().then();

  }, [getPickupAddresses, getDeliveryAddresses]);

  return (
    <Formik
      initialValues={data}
      onSubmit={handleSubmit}
      validationSchema={mySchema(data)}
    >

      {({
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        isSubmitting,
        errors,
        touched,
      }) => {

        const enhancedHandleChange = (e) => {
          handleChange(e);

          // Check if it's a postcode field and process STC accordingly
          if ((e.target.name === 'delivery_postcode' || e.target.name === 'owner_postcode') &&
            e.target.value.length === 4 &&
            /^\d{4}$/.test(e.target.value)) {
            processSTCForPostcode(e.target.value, data.trading_stc);
          }
        };

        return (
          <>
            <Form onSubmit={handleSubmit}>

              <div className="shipping">


                <h2 className="ps-0 ms-0" id="submit-anchor">Order Pickup or Delivery Options</h2>
                <hr className="mb-5" />


                <p>Choose between pick-up (free) or delivery <RequiredAsterisk /></p>

                <div className={'border rounded p-3 mb-4 ' + (touched.delivery_method && errors.delivery_method && ' border-danger')}>

                  <div className="form-check">
                    <Field className="form-check-input" type="radio"
                      name="delivery_method"
                      id="delivery_method1"
                      value="1"
                      checked={values.delivery_method === '1'}
                      onChange={e => {

                        /* get the pickup addresses */
                        getPickupAddresses().then();

                        values.delivery_service = '';
                        values.shipping = '';

                        if (cartItems.find(item => item.id === 0)) {
                          removeFromCart(0);
                        }

                        setData((prev) => ({ ...prev, delivery_method: '1' }));
                        handleChange(e);
                      }}
                    />
                    <label className="form-check-label" htmlFor="delivery_method1">
                      1. Pick-up at iStore branch or warehouse. (free)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field className="form-check-input" type="radio"
                      name="delivery_method"
                      id="delivery_method2"
                      value="2"
                      checked={values.delivery_method === '2'}
                      onChange={e => {
                        getDeliveryAddresses(e).then();
                        values.shipping = '';
                        if (auth.user_state !== 'WA') {
                          setData((prev) => ({ ...prev, delivery_method: '2', shipping: '', delivery_service: '3' }));
                          values.delivery_service = '3';
                          addDeliveryService('3');
                          setShowFreightModal(true);
                          handleChange(e);
                          handleChange({ target: { value: '3', name: 'delivery_service' } });
                        } else {
                          setData((prev) => ({ ...prev, delivery_method: '2', shipping: '' }));
                          values.delivery_service = '';
                          handleChange(e);
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="delivery_method2">
                      2. Deliver to my own saved address.
                    </label>
                  </div>
                  <div className="form-check">
                    <Field className="form-check-input" type="radio"
                      name="delivery_method"
                      id="delivery_method3"
                      value="3"
                      checked={values.delivery_method === '3'}
                      onChange={e => {
                        values.shipping = '';
                        if (auth.user_state !== 'WA') {
                          setData((prev) => ({ ...prev, delivery_method: '3', shipping: '', delivery_service: '3' }));
                          values.delivery_service = '3';
                          addDeliveryService('3');
                          setShowFreightModal(true);
                          handleChange(e);
                          handleChange({ target: { value: '3', name: 'delivery_service' } });
                        } else {
                          setData((prev) => ({ ...prev, delivery_method: '3', shipping: '' }));
                          values.delivery_service = '';
                          handleChange(e);
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="delivery_method3">
                      3. Deliver direct to my customer or a new address
                    </label>
                  </div>

                  {touched.delivery_method && errors.delivery_method && <p className="small text-danger">{errors.delivery_method}</p>}

                </div>


                {
                  data.delivery_method === '1' &&
                  <div className={`border rounded p-3 mb-4 ${touched.shipping && errors.shipping && ' border-danger'}`}>
                    <div className="mb-2 text-primary fw-bold">1. Pick-up at an iStore Warehouse. Please Select</div>
                    {loadingPickupAddresses ? <CircularProgress /> :
                      <Fragment>
                        {Object.entries(pickupAddresses).map(([key, addresses], id) => {
                          return (

                            <ul key={id}>
                              <strong>{key}</strong>
                              {Object.values(addresses).map((address, aid) => (

                                <div className="form-check" key={aid}>
                                  <label>
                                    <Field
                                      name="shipping"
                                      className="form-check-input"
                                      type="radio"
                                      checked={data.shipping === String(address.id)}
                                      value={address.id}
                                      onChange={e => {
                                        handleChange(e);
                                        setData((prev) => ({ ...prev, shipping: e.target.value }));
                                      }}
                                    />
                                    {address.company} - {address.street1} {address.suburb} {address.state} {address.postcode}
                                    <br />
                                  </label>
                                  <div className="small text-black-50 ps-2">{address.notes}</div>
                                </div>

                              ))}
                            </ul>

                          );
                        })}
                      </Fragment>
                    }
                    {touched.shipping && errors.shipping && <p className="small text-danger">The pick-up address is required.</p>}

                    <p><strong>Pick-up By <RequiredAsterisk /></strong></p>
                    <div className="btn-group mb-4" role="group" aria-label="Pick-up by">
                      <Field type="radio" className="btn-check" id="pikcup-by-2" autoComplete="off"
                        value="2"
                        name="pickup_by"
                        checked={values.pickup_by === '2'}
                        onChange={(e) => {
                          handleChange(e);
                          setData((prev) => ({ ...prev, pickup_by: '2' }));
                        }}

                      />
                      <label className="btn btn-outline-primary" htmlFor="pikcup-by-2">Pick-up by myself or my representative</label><br />
                      <Field type="radio" className="btn-check" id="pickup-by-1" autoComplete="off"
                        value="1"
                        name="pickup_by"
                        checked={values.pickup_by === '1'}
                        onChange={(e) => {
                          handleChange(e);
                          setData((prev) => ({ ...prev, pickup_by: '1' }));

                        }}
                      />


                      <label className="btn btn-outline-primary" htmlFor="pickup-by-1">Transport Agency</label>

                    </div>
                    {
                      data.pickup_by === '1' &&
                      <div>

                        <Field type="text" className="form-control mb-3" id="pickup-by-agency"
                          value={values.pickup_by_agency}
                          placeholder="Enter the Transport Agency Company Name"
                          name="pickup_by_agency"
                          onChange={(e) => {
                            handleChange(e);
                            setData((prev) => ({ ...prev, pickup_by_agency: e.target.value }));
                          }}
                        />
                        {touched.pickup_by_agency && errors.pickup_by_agency && <p className="small text-danger">{errors.pickup_by_agency}</p>}
                        <Alert severity="warning" className="border mb-3">Please provide a separate <strong>Transport Consignment Note</strong> label for this pick-up.</Alert>
                      </div>

                    }

                    {touched.pickup_by && errors.pickup_by && <p className="small text-danger">{errors.pickup_by}</p>}

                  </div>
                }

                {
                  data.delivery_method === '2' &&
                  <div className={'border rounded p-3 mb-4 ' + (touched.shipping && errors.shipping && ' border-danger')}>
                    <div className="mb-2 text-primary fw-bold">2. Deliver to my saved delivery address.</div>
                    {loadingDeliveryAddresses ? <CircularProgress /> :
                      <Fragment>
                        {deliveryAddresses?.length > 0 ?

                          <Fragment>
                            {Object.values(deliveryAddresses).map((a) => {
                              return (
                                <div className="form-check" key={a.id}>
                                  <label>
                                    <Field
                                      name="shipping"
                                      className="form-check-input"
                                      type="radio"
                                      checked={data.shipping === String(a.id)}
                                      value={a.id}
                                      onChange={e => {
                                        handleChange(e);
                                        setData((prev) => ({ ...prev, shipping: e.target.value }));
                                      }}
                                    />
                                    {a.company} - {a.street1} {a.suburb} {a.state} {a.postcode}
                                  </label>
                                </div>
                              );
                            })}
                          </Fragment>
                          : <p>You can save up to 10 addresses for quick checkout in your <Link to="/address-book">address
                            book</Link></p>
                        }
                      </Fragment>
                    }
                    {touched.shipping && errors.shipping && <p className="small text-danger">The delivery address is required.</p>}

                  </div>
                }

                {
                  data.delivery_method === '3' &&
                  <div className={'border rounded p-3 mb-4 ' + (touched.shipping && errors.shipping && ' border-danger')}>
                    <div className="mb-2 text-primary fw-bold">3. Deliver direct to my customer address</div>
                    <div className="form-check">
                      <label>
                        <Field
                          name="shipping"
                          className="form-check-input"
                          type="radio"
                          checked={data.shipping === '0'}
                          value="0"
                          onChange={e => {
                            handleChange(e);
                            setData((prev) => ({ ...prev, shipping: '0' }));
                          }}
                        />&nbsp;
                      </label>
                      Create a new delivery address
                      {touched.shipping && errors.shipping && <p className="small text-danger">The new delivery address is required.</p>}

                    </div>

                    <div className="pt-3">
                      {
                        data.shipping === '0' &&
                        <DeliveryAddress values={values} errors={errors} touched={touched} handleChange={enhancedHandleChange} handleBlur={handleBlur} />
                      }
                    </div>

                  </div>

                }


                {
                  auth.user_state === 'WA' && (data.delivery_method === '2' || data.delivery_method === '3') ?
                    <div className="p-3 mb-4" style={touched.delivery_service && errors.delivery_service ? {
                      border: '1px solid red',
                      borderRadius: '5px'
                    } : { border: '1px solid #ccc', borderRadius: '5px' }}>

                      <p><strong>Choose an iStore Delivery Service <RequiredAsterisk /></strong></p>
                      <div className="btn-group mb-4" role="group" aria-label="Choose an iStore Delivery Service">

                        <Field type="radio" className="btn-check" id="delivery-service-1" autoComplete="off" value="1"
                          name="delivery_service"
                          checked={values.delivery_service === '1'}
                          onChange={(e) => {
                            handleChange(e);
                            setData((prev) => ({ ...prev, delivery_service: '1' }));
                            addDeliveryService(e.target.value);
                          }}
                        />
                        <label className="btn btn-outline-primary" htmlFor="delivery-service-1">Driveway Drop & Go</label>

                        <Field type="radio" className="btn-check" id="delivery-service-2" autoComplete="off" value="2"
                          name="delivery_service"
                          checked={values.delivery_service === '2'}
                          onChange={(e) => {
                            handleChange(e);
                            setData((prev) => ({ ...prev, delivery_service: '2' }));
                            addDeliveryService(e.target.value);
                          }}
                        />
                        <label className="btn btn-outline-primary" htmlFor="delivery-service-2">Full Drop & Go</label>

                      </div>

                      <p className="small text-black-50">
                        <strong>Driveway</strong> – Delivery to location only.<br />
                        <strong>Full Drop and Go</strong> – Delivery, position assist, rubbish and old HWS recycled.
                      </p>

                      {touched.delivery_service && errors.delivery_service ?
                        <p style={{ letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px' }}
                          className="text-danger">{errors.delivery_service}</p> : null}

                    </div>
                    : null
                }

                <div className="mb-4 p-4 border rounded">
                  <FormControl fullWidth className="mb-4">
                    <FormLabel id="install-date" className="fw-bold mb-3">
                      {values.trading_stc === '1' ? "What is your Installation Date?" : "What is your proposed pickup/delivery date?"}
                      <RequiredAsterisk />
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="install_date"
                        value={data.install_date}
                        label={values.trading_stc === '1' ? "Installation Date" : "Proposed Pickup/Delivery date"}
                        format="DD/MM/YYYY"
                        minDate={dayjs()}
                        shouldDisableDate={(date) => date.day() === 0 || date.day() === 6}
                        slotProps={{
                          textField: {
                            error: !!(touched.install_date && errors.install_date),
                            onBlur: handleBlur,
                            name: 'install_date'
                          }
                        }}
                        onChange={date => {
                          handleChange({
                            target: {
                              value: date,
                              name: 'install_date'
                            }
                          });
                          setData(prev => ({ ...prev, install_date: date }));
                        }}
                      />
                    </LocalizationProvider>
                    <ErrorMessage component="div" name="install_date" className="help-block errors text-danger" />
                  </FormControl>
                </div>

                <div className="mb-4 p-4 border rounded">

                  <FormControl fullWidth className="mb-5">
                    <FormLabel id="customer-order-no-label" className="fw-bold mb-3">Your Purchase Order/Customer Reference <RequiredAsterisk /></FormLabel>
                    <TextField id="customer-order-no" label="Purchase Order/Customer Reference" name="customer_order_no"
                      value={values.customer_order_no}
                      error={!!(touched.customer_order_no && errors.customer_order_no)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage component="div" name="customer_order_no" className="help-block errors text-danger" />
                  </FormControl>

                </div>

                <div className="mb-4 p-4 border rounded">
                  <FormControl fullWidth className="mb-4">
                    <FormLabel id="trading-stc" className="fw-bold">Are you trading STC's with
                      iStore? <RequiredAsterisk /></FormLabel>
                    <RadioGroup aria-labelledby="trading-stc" name="trading_stc"
                      value={data.trading_stc}
                      onChange={e => handleSTCChange(e, handleChange)}
                    >
                      <FormControlLabel value="0" control={<Radio value="0" />} label="NO - NOT TRADING STC's" />
                      <FormControlLabel value="1" control={<Radio value="1" />} label="YES - TRADING STC's With iStore" />
                    </RadioGroup>
                  </FormControl>

                </div>

                <FormControl fullWidth className="mb-4">
                  <FormLabel id="order-notes" className="fw-bold mb-2">Order Notes</FormLabel>
                  <TextField multiline rows='3' name="order_notes"
                    placeholder="Do you have any order notes for our Team?"
                    value={values.order_notes}
                    onChange={handleChange}
                  />
                </FormControl>

                <Alert className="mb-3 border" severity="error">Transport details – The iStore 180L and 270L units must be side strapped and
                  remain upright during transport. Read more in our <Link to="/bulletin">Tech Bulletin</Link></Alert>

                <DeliveryAlert values={values} shipping={data.shipping} deliveryMethod={data.delivery_method} />

              </div>
              <Row style={{ marginBottom: '40px' }}>
                  <Col xs={12} className="text-end">

                    <Backdrop
                      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                      open={isSubmitting}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>

                    <Button disabled={isSubmitting} size="large" variant="contained"
                      type="submit"
                      endIcon={data.trading_stc === '0' && <SendIcon />}
                    >
                      {data.trading_stc === '0' ? 'Place Order' : 'Next'}
                    </Button>

                  </Col>
                </Row>
            </Form>

            {/* Freight Service Notice Modal */}
            <Dialog
              open={showFreightModal}
              onClose={() => setShowFreightModal(false)}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: '0.375rem',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #dee2e6'
                }
              }}
            >
              <DialogTitle
                sx={{
                  background: '#042942',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  padding: '16px 24px',
                  borderBottom: '1px solid #dee2e6'
                }}
              >
                Freight Delivery Notice
              </DialogTitle>
              <DialogContent
                sx={{
                  padding: '24px',
                  backgroundColor: 'rgba(248, 249, 250, 0.8)'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: '#495057',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                    paddingTop: '20px',
                  }}
                >
                  The iStore Admin will be quoting the freight delivery before the order can be released. An updated order with freight charge will be sent to you soon for payment.
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  padding: '16px 24px',
                  backgroundColor: '#ffffff',
                  borderTop: '1px solid #f1f3f4'
                }}
              >
                <Button
                  onClick={handleFreightConfirm}
                  variant="contained"
                  autoFocus
                  sx={{
                    backgroundColor: '#0d6efd',
                    '&:hover': {
                      backgroundColor: '#0056b3'
                    },
                    minHeight: '40px',
                    borderRadius: '0.375rem'
                  }}
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={showSTCModal}
              onClose={() => setShowSTCModal(false)}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: '0.375rem',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  border: '1px solid #dee2e6'
                }
              }}
            >
              <DialogTitle
                sx={{
                  background: '#042942',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '1.25rem',
                  padding: '16px 24px',
                  borderBottom: '1px solid #dee2e6'
                }}
              >
                Trading STC Confirmation
              </DialogTitle>
              <DialogContent
                sx={{
                  padding: '24px',
                  backgroundColor: 'rgba(248, 249, 250, 0.8)'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: '#495057',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                    paddingTop: '20px',
                  }}
                >
                  Pending - To be verified by Admin
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  padding: '16px 24px',
                  backgroundColor: '#ffffff',
                  borderTop: '1px solid #f1f3f4'
                }}
              >
                <Button
                  onClick={() => handleSTCConfirm(handleChange)}
                  variant="contained"
                  autoFocus
                  sx={{
                    backgroundColor: '#0d6efd',
                    '&:hover': {
                      backgroundColor: '#0056b3'
                    },
                    minHeight: '40px',
                    borderRadius: '0.375rem'
                  }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )
      }}


    </Formik>
  );
};

export default CheckOutForm1;